import React from 'react';
import PropTypes from 'prop-types';
import Price from "components/Price";
import IconCencosudCard from 'components/IconCencosudCard';
import logoPrime from 'images/icons/logo-jumbo-prime.svg';
import PromotionFactory from 'factories/Promotion';
import { HtmlParse } from 'utils/index'
import LoginService from 'services/Login'
import style from './style.scss';//NOSONAR


const ProductPrices = ({ item, skuData, productDetail }) => {
    let isRefToNormal = false
    let isReferential = false

    const getPrices = () => {
        if (!item) return [];

        const userIsPrime = LoginService.isPrime();
        const promotions = PromotionFactory.create(item, skuData);

        let productPrices = item.prices || {
            old: 0,
            oldPpum: 0,
            regular: 0,
            regularPpum: 0
        }

        let unitMeasurement = '';
        if(item.measurementUnit === 'kg' && item.unitMultiplier < 1){
            unitMeasurement = (item.unitMultiplier * 1000) + ' g';
        } else if(item.measurementUnit === 'kg' && item.unitMultiplier > 1){
            unitMeasurement = (item.unitMultiplier + ' ' + item.measurementUnit);
        } else {
            unitMeasurement = ((item.unitMultiplier || 1) + ' ' + (item.measurementUnit || 'un'));
        }

        const isOffer = promotions.filter((promotion) => {
            if (promotion.type === 'for_the_price_of' && productPrices.old && productPrices.old > productPrices.regular) {
                if (promotion.title === '2X') {
                    isReferential = true
                }

                isRefToNormal = true
            }

            return promotion.type === 'regular' && !promotion.tcenco && (!promotion.cencoPrime || userIsPrime)
        }).length > 0

        let priceItem = [];

        if (!isOffer) {
            if (productPrices.old && (productPrices.old > productPrices.regular)) {
                priceItem.push({
                    title: false,
                    type: 'referential-price',
                    subtitle: false,
                    oldPrice: productPrices.old,
                    oldPpum: productPrices.oldPpum,
                    measurementUnit: skuData ? skuData.measurement_unit_un : 0,
                    isPriceView: true,
                    unitMeasurement: unitMeasurement
                });
            }

            priceItem.push({
                title: false,
                type: 'regular',
                subtitle: false,
                price: productPrices.regular,
                pricePpum: productPrices.regularPpum,
                measurementUnit: skuData ? skuData.measurement_unit_un : 0,
                isPriceView: true,
                unitMeasurement: unitMeasurement
            });
        } else {
            priceItem.push({
                title: false,
                type: '',
                subtitle: false,
                oldPrice: isOffer ? productPrices.old : false,
                price: isOffer ? false : productPrices.regular,
                oldPpum: productPrices.oldPpum,
                pricePpum: isOffer ? productPrices.oldPpum : productPrices.regularPpum,
                measurementUnit: skuData ? skuData.measurement_unit_un : 0,
                isPriceView: true,
                unitMeasurement: unitMeasurement
            });
        }

        priceItem = priceItem.concat(promotions);

        promotions.map(promotion => {
            if (promotion.tcenco) {
                promotion.description
            }
        });

        return priceItem;
    }

    const prices = getPrices();

    if(prices.length === 1){
        const item = prices[0];
        return (
            <div className={'product-single-price' + (productDetail ? ' product-single-pdp' : '')}>
                <div className="product-single-price-container">
                    <span className="product-sigle-price-wrapper">
                        <Price price={item.price} />
                    </span>
                    {item.measurementUnit === 'kg' && !!item.pricePpum && !!item.measurementUnit ? (
                        <div className={'ppum-wrapper'}>
                            <div className="product-price-ppum">
                                <Price price={item.pricePpum} /> x {item.measurementUnit}
                            </div>
                            <span className="price-label">(Normal)</span>
                        </div>
                    ) : (
                        <span className="price-label">
                            (Normal)
                        </span>
                    )}
                </div>
            </div>
        )
    }

    return (
        <div className={'prices-product' + (productDetail ? ' pdp' : '')}>
            {prices.map((item, i) => {
                const titlePromo = item.title && item.isPriceView && item.title.length < 12 ? item.title : ''
                const titlePromoIsMoreProducts =
                    item.title && item.title.split('%').length > 1 ? item.title.split('%')[0] + '% de dcto.' : item.title
                const subtitleIsMoreProducts = item.title && item.title.split('%').length > 1 ? 'en la ' + item.title.split('%')[1] : ''

                return (
                    <div
                        className={
                            'price-product-item ' +
                            (item.isPromotion ? 'promotion ' : '') +
                            (item.type + " ") +
                            (item.tcenco ? 'tcenco ' : '') +
                            (item.cencoPrime ? 'prime ' : '') +
                            (item.isPriceView ? '' : 'promotion-box-wrapper ') +
                            (item.isPriceView && !item.title ? 'price-with-unit ' : '') +
                            (productDetail ? 'price-unit-pdp ' : '') +
                            (subtitleIsMoreProducts.includes('unid.') && productDetail ? 'promotion-pdp ' : '') +
                            (item.oldPrice && !item.price ? 'old-price-only ' : '') +
                            (isReferential ? 'is-referential ' : '') +
                            (isRefToNormal ? 'is-ref-to-normal' : '') 
                        }
                        key={i}>
                        {item.isPriceView && (
                            <div className={'price-product-text'}>
                                {item.oldPrice && (
                                    <div className='price-product-old-price'>
                                        <span className='price-product-value'>
                                            <Price price={item.oldPrice} />
                                        </span>
                                        <span className="ppum-wrapper">
                                            {item.measurementUnit === 'kg' && !item.title && !!item.pricePpum && !!item.measurementUnit && (
                                                <span className="product-price-ppum">
                                                    (<Price price={item.oldPpum} /> x {item.measurementUnit})
                                                </span>
                                            )}
                                            {isRefToNormal ? (
                                                <span className="price-label">{isReferential ? '(Ref.)' : '(Normal)'}</span>
                                            ) : (
                                                <span className="price-label">{'(Ref.)'}</span>
                                            )}
                                        </span>
                                    </div>
                                )}
                                <div className="price-product-best-wrap">
                                    <div className='price-product-content'>
                                        {item.price && (
                                            <span className={'price-product-best' + (!item.isPromotion && !item.title && item.oldPrice ? ' highlight ' : '')}>
                                                {titlePromo && (
                                                    <span className="price-product-prom">
                                                        {titlePromo}
                                                    </span>
                                                )}
                                                <span className="price-wrapper">
                                                    <span className="price-best">
                                                        <Price price={item.price} />
                                                    </span>
                                                    <div className="ppum-wrapper">
                                                        {item.measurementUnit === 'kg' && !item.oldPrice && item.isPriceView && !!item.pricePpum && !!item.measurementUnit && (
                                                            <span className='product-price-ppum'>
                                                                (<Price price={item.pricePpum} /> x {item.measurementUnit})
                                                            </span>
                                                        )}
                                                        {item.isPriceView && !item.title ? (
                                                            <span className="price-label">
                                                                {isRefToNormal ? '' : '(Normal)'}
                                                            </span> 
                                                        ) : ''}
                                                    </div>
                                                </span>
                                            </span>
                                        )}
                                    </div>
                                    {item.tcenco && !item.oldPrice && <IconCencosudCard className="prices-tcenco-logo" />}
                                    {item.cencoPrime && <i className="logo-prime">{HtmlParse(logoPrime)}</i>}
                                </div>
                            </div>
                        )}
                        {!item.isPriceView && (
                            <div
                                className={
                                    'price-product-label ' +
                                    (productDetail ? 'price-mxn-content ' : '') +
                                    (subtitleIsMoreProducts.includes('unid.') ? 'promotion-porcentual-content ' : '') +
                                    (item.isPriceView ? 'center-content ' : '')
                                }>
                                <span className={'price-product-label-title'}>
                                    <div
                                        className={
                                            'price-product-best-wrap ' +
                                            (productDetail && subtitleIsMoreProducts.includes('unid.') ? ' pdp' : '')
                                        }>
                                        <div
                                            className={
                                                'promotion-title-product-best price-promotion-mxn' +
                                                (productDetail ? ' promotion-mxn-pdp ' : '') +
                                                (subtitleIsMoreProducts.includes('unid.') ? ' promotion-porcentual' : '') +
                                                (item.tcenco && productDetail ? ' tcenco-pdp ' : '') +
                                                (!item.tcenco && !productDetail ? ' regular-plp' : '')
                                            }>
                                            <span
                                                className={
                                                    'price-product-best price-promotion-mxn ' + (productDetail ? ' promotion-mxn-pdp ' : '')
                                                }>
                                                {titlePromoIsMoreProducts}
                                            </span>
                                            {subtitleIsMoreProducts && (
                                                <div className={'price-product-subtitle ' + (productDetail ? ' pdp' : '')}>
                                                    {subtitleIsMoreProducts}
                                                </div>
                                            )}
                                        </div>
                                        {item.tcenco && <IconCencosudCard className="prices-tcenco-logo" />}
                                        {item.cencoPrime && <i className="logo-prime">{HtmlParse(logoPrime)}</i>}
                                        {prices.length > 0 && prices.filter((item) => !item.isPriceView).filter(Boolean).length > 0 && (
                                            <div className={'price-product-label-msg plp'}>Aplica sobre Precio Normal</div>
                                        )}
                                    </div>
                                </span>
                            </div>
                        )}
                    </div>
                )
            })}
        </div>
    )
}

ProductPrices.propTypes = {
    item: PropTypes.object,
    skuData: PropTypes.object,
    settings: PropTypes.object,
    priceOld: PropTypes.bool,
    productDetail: PropTypes.bool
};

export default ProductPrices;
